let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1FABL")).then(() => parcelRequire('ko7mk'));